import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onBeforeUnmount } from 'vue'
import axios from 'axios'
import { Auth } from 'aws-amplify'
import { API_LOCATION } from '@/api-config'
import { formatGroupDate, formatGroupTime } from '@/plugins/dates'
import { tagChipStyle } from '@/util/tagChip'
import { EMAIL_STATUS_LABELS, EMAIL_STATUS_COLORS, EMAIL_EVENT_LABELS, emailLabel, emailSourceLabel, eventToStatus } from './emailLogLabels'


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailLogDrawer',
  props: {
    show: { type: Boolean },
    event: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({ (e: 'close'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { show: boolean; event: any | null }

// Read-only detail for one row of the email log. Opening it fetches the message's
// event timeline (every SES event for its message id) from get-email-log-for-group.



const statusKey = computed(() => (props.event ? eventToStatus(props.event.latest_event) : 'sent'))
const statusLabel = computed(() => EMAIL_STATUS_LABELS[statusKey.value])
const statusColor = computed(() => EMAIL_STATUS_COLORS[statusKey.value])
const recipientName = computed(() =>
  props.event ? [props.event.recipient_first_name, props.event.recipient_last_name].filter(Boolean).join(' ') : '')

const history = ref<any[]>([])
const loadingHistory = ref(false)
const companyId = localStorage.getItem('companyId')
const companyGroupId = JSON.parse(localStorage.getItem('group') || '{}').id

function eventLabel(h: any) {
  const base = EMAIL_EVENT_LABELS[h.event_type] || h.event_type
  return h.event_type === 'Bounce' && h.bounce_type ? base + ' (' + String(h.bounce_type).toLowerCase() + ')' : base
}

// Every event of the message, oldest first; a legacy row without a message id has only its send
async function loadHistory() {
  history.value = []
  if (!props.event || !props.event.message_id) return
  loadingHistory.value = true
  try {
    const session = await Auth.currentSession()
    const config = { headers: { Authorization: (session as any).idToken.jwtToken } }
    const url = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}/email-log?message_id=${encodeURIComponent(props.event.message_id)}`
    const response = await axios.get(url, config)
    history.value = response.data.history || []
  } catch (e) {
    history.value = []
  } finally {
    loadingHistory.value = false
  }
}

function formatWhen(value: string) {
  if (!value) return ''
  try {
    return formatGroupDate(value) + ' ' + formatGroupTime(value)
  } catch (e) {
    return String(value).slice(0, 16)
  }
}

function onClose() {
  emit('close')
}
function onEscKey(e: KeyboardEvent) {
  if (e.key === 'Escape') onClose()
}
watch(() => props.show, (visible) => {
  if (visible) {
    document.addEventListener('keydown', onEscKey)
    loadHistory()
  } else {
    document.removeEventListener('keydown', onEscKey)
  }
})
onBeforeUnmount(() => {
  document.removeEventListener('keydown', onEscKey)
})

return { __sfc: true,props, emit, statusKey, statusLabel, statusColor, recipientName, history, loadingHistory, companyId, companyGroupId, eventLabel, loadHistory, formatWhen, onClose, onEscKey, tagChipStyle, emailLabel, emailSourceLabel }
}

})